<template lang="pug">
div.datepicker(ref="container")
    div.btn-group.summary-group
        .summary
            button.btn.white.btn-block(
                :class="{'popup-open': showPopup, 'popup-close': !showPopup}"
                @click="popup()"
            ) {{ title }}

    .datepicker-popup(v-if="showPopup")
        .datepicker-body
            slot(name="body")
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            showPopup: false,
        };
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside, true);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside, true);
    },

    methods: {
        closePopup(s) {
            this.showPopup = false;
        },

        openPopup() {
            this.showPopup = true;
        },

        popup() {
            if (this.showPopup) {
                this.closePopup();
            } else {
                this.openPopup();
            }
        },

        handleClickOutside(e) {
            const el = this.$refs.container;

            if (!el.contains(e.target)) {
                if (this.showPopup) {
                    this.showPopup = false;
                }
            }
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@use '../../../sass/mixins';

$border-color: #ccc;

.datepicker {
    position: relative;
}

.datepicker-body {
    width: 360px;
    display: inline-block;
}

.datepicker-popup {
    position: absolute;
    right: 0;
    border: 1px solid $border-color;
    border-radius: 5px;
    background: #fff;
    margin-top: 2px;
    z-index: 1000;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.summary-group {
    width: 100%;
    display: flex;

    .chevron {
        display: inline-block;
        width: 0;
        height: 0;
        margin-right: 0.25rem;
        margin-left: 0.25rem;
        vertical-align: middle;
        content: '';
    }

    .prev {
        float: left;
        margin-right: -1px;

        &::after {
            @extend .chevron;
            border-top: 0.3em solid transparent;
            border-right: 0.3em solid;
            border-bottom: 0.3em solid transparent;
        }
    }

    .summary {
        overflow: hidden;
        flex-grow: 1;
        margin-left: -1px;
        margin-right: -1px;

        .btn {
            width: 100%;
        }

        .popup-open {
            &::after {
                @extend .chevron;
                border-bottom: 0.3em solid;
                border-left: 0.3em solid transparent;
                border-right: 0.3em solid transparent;
            }
        }

        .popup-close {
            &::after {
                @extend .chevron;
                border-left: 0.3em solid transparent;
                border-right: 0.3em solid transparent;
                border-top: 0.3em solid;
            }
        }
    }

    .next {
        float: right;

        &::after {
            @extend .chevron;
            border-top: 0.3em solid transparent;
            border-left: 0.3em solid;
            border-bottom: 0.3em solid transparent;
        }
    }
}
</style>
